import LangEnum from '../../../lang/LangEnum';

export type OrderConditionFieldWithError =
  | 'paymentId'
  | 'commercialPolicyId'
  | 'voucherId'
  | 'deliveryAddressId'
  | 'shippingCompanyId'
  | 'billingForecastDate'
  | 'orderCollectionId'
  | 'saleTypeId'
  | 'branchId'
  | 'freightType'
  | 'orderOperationCode'
  | 'orderChargeTypeCode'
  | 'orderBatchItemCode';

export const FIELDS_BY_ERROR_CODE: Partial<Record<LangEnum, OrderConditionFieldWithError[]>> = {
  [LangEnum.ORDER_RULE_PAYMENT_METHOD_REQUIRED_RULE]: ['paymentId'],
  [LangEnum.ORDER_RULE_PAYMENT_METHOD_AVAILABILITY_RULE]: ['paymentId'],
  [LangEnum.ORDER_RULE_PAYMENT_METHOD_CUSTOMER_RULE]: ['paymentId'],
  [LangEnum.PAYMENT_METHOD_NOT_AVAILABLE_FOR_USER]: ['paymentId'],
  [LangEnum.ORDER_RULE_ORDER_BUSINESS_POLICY_PAYMENT_METHOD_RULE]: ['paymentId'],
  [LangEnum.ORDER_RULE_PAYMENT_METHOD_COMMERCIAL_POLICY_UNAVAILABLE]: [
    'paymentId',
    'commercialPolicyId',
  ],
  [LangEnum.ORDER_RULE_COMMERCIAL_DISCOUNT_UNAVAILABLE_RULE]: ['commercialPolicyId'],
  [LangEnum.ORDER_RULE_COMMERCIAL_DISCOUNT_MAX_PERCENTAGE_RULE]: [
    'paymentId',
    'commercialPolicyId',
  ],
  [LangEnum.ORDER_RULE_COMMERCIAL_POLICY_ORDER_PAYMENT_METHOD_RULE]: [
    'paymentId',
    'commercialPolicyId',
  ],
  [LangEnum.ORDER_RULE_COMMERCIAL_POLICY_NOT_AVAILABLE_RULE]: ['commercialPolicyId'],
  [LangEnum.ORDER_RULE_COMMERCIAL_POLICY_AVAILABILITY_RULE]: ['commercialPolicyId'],
  [LangEnum.ORDER_RULE_COMMERCIAL_POLICY_ORDER_CUSTOMER_RULE]: ['commercialPolicyId'],
  [LangEnum.ORDER_RULE_COMMERCIAL_POLICY_ORDER_COLLECTION_RULE]: [
    'commercialPolicyId',
    'orderCollectionId',
  ],
  [LangEnum.ORDER_RULE_ORDER_BUSINESS_POLICY_CRITERIA_VOUCHER_RULE]: ['voucherId'],
  [LangEnum.ORDER_RULE_ORDER_BUSINESS_POLICY_CRITERIA_VOUCHER_APPLY_AGAIN_RULE]: ['voucherId'],
  [LangEnum.ORDER_RULE_ORDER_BUSINESS_POLICY_USED_VOUCHER_PER_CUSTOMER]: ['voucherId'],
  [LangEnum.ORDER_RULE_ORDER_BUSINESS_POLICY_VOUCHER_INACTIVE_RULE]: ['voucherId'],
  [LangEnum.ORDER_RULE_ORDER_BUSINESS_POLICY_VOUCHER_EXPIRED_RULE]: ['voucherId'],
  [LangEnum.ORDER_RULE_INVALID_VOUCHER_RULE]: ['voucherId'],
  [LangEnum.ORDER_RULE_DELIVERY_ADDRESS_REQUIRED_RULE]: ['deliveryAddressId'],
  [LangEnum.ORDER_RULE_SHIPPING_COMPANY_REQUIRED_RULE]: ['shippingCompanyId'],
  [LangEnum.ORDER_RULE_BILLING_FORECAST_REQUIRED_RULE]: ['billingForecastDate'],
  [LangEnum.ORDER_RULE_COLLECTION_REQUIRED_RULE]: ['orderCollectionId'],
  [LangEnum.ORDER_RULE_SALE_TYPE_REQUIRED_RULE]: ['saleTypeId'],
  [LangEnum.ORDER_RULE_BRANCH_REQUIRED]: ['branchId'],
  [LangEnum.ORDER_RULE_FREIGHT_TYPE_REQUIRED_RULE]: ['freightType'],
  [LangEnum.ORDER_OPERATION_CODE_REQUIRED_RULE]: ['orderOperationCode'],
  [LangEnum.ORDER_RULE_ORDER_CHARGE_TYPE_CODE_REQUIRED_RULE]: ['orderChargeTypeCode'],
  [LangEnum.ORDER_BATCH_ITEM_CODE_REQUIRED_RULE]: ['orderBatchItemCode'],
};

export const MORE_CONDITIONS_FIELDS: OrderConditionFieldWithError[] = [
  'orderCollectionId',
  'saleTypeId',
  'branchId',
  'freightType',
  'shippingCompanyId',
  'orderOperationCode',
  'orderChargeTypeCode',
  'orderBatchItemCode',
];

export const ORDER_WIDE_ERROR_CODES: LangEnum[] = [
  LangEnum.ORDER_RULE_ORDER_WITHOUT_ITEMS_RULE,
  LangEnum.ORDER_RULE_ORDER_MINIMUM_VALUE_RULE,
  LangEnum.ORDER_RULE_ORDER_CONTRACT_SIGNATURE_REQUIRED_BY_STORE_RULE,
  LangEnum.ORDER_RULE_ORDER_CONTRACT_SIGNATURE_REQUIRED_BY_STORE_AND_BRAND_RULE,
];
